module.exports = __webpack_public_path__ + "img/notify-bell.7aa74231.svg";